<template>
<div>
  <div class="rr-alert">
    <!-- <b-alert show variant="success">Our kitchen takes orders from noon - 8:30 PM <a href="#announcement-anchor">See announcement</a></b-alert> -->
  </div>
  <div class="row">
    <div class="col-12 col-md-6 home">
      <div class="social-container">
        <a href="https://www.tripadvisor.com/Restaurant_Review-g47565-d4681386-Reviews-Red_Rooster_Bistro-Cutchogue_North_Fork_Long_Island_New_York.html?m=19905" target="_blank" rel=”noreferrer”><img src="../assets/trip-advisor.svg" class="social" alt="Link to Trip Advisor" aria-label="Link to Trip Advisor"/></a>
        <a href="https://www.yelp.com/biz/red-rooster-bistro-cutchogue" target="_blank" rel=”noreferrer” class="left-space"><img src="../assets/yelp.svg" class="social" alt="Link to Yelp" aria-label="Link to Yelp"/></a>
        <a href="https://www.facebook.com/RedRoosterBistro1/" target="_blank" rel=”noreferrer” class="left-space"><img src="../assets/facebook.svg" class="social" alt="Link to Facebook" aria-label="Link to Facebook"/></a>
        <a href="https://www.instagram.com/redroostercutchogue" target="_blank" rel=”noreferrer” class="left-space"><img src="../assets/instagram.svg" class="social" alt="Link to Instagram" aria-label="Link to Instagram"/></a>
        <a href="https://goo.gl/maps/dBWK2d3yxu1Cr6Au5" target="_blank" rel=”noreferrer” class="left-space"><img src="../assets/google.svg" class="social" alt="Link to Google Maps" aria-label="Link to Google Maps"/></a>
      </div>
      <div class="home-content">
        <h2 class="page-header">Red Rooster Bistro</h2>
        <template v-for="(announcement, index) in announcements">
          <app-announcement class="anouncement-width"
            :key="announcement.title"
            :index="index"
            :msgTitle="announcement.title"
            :message="announcement.message"
            :link="announcement.link"
            :imageUrl="announcement.imageUrl"></app-announcement>
        </template>
      </div>
      <div class="home-border"></div>
    </div>
    <div class="col-12 col-md-6 home-content">
        <!-- <p class="blurb-width">Serving French-American cuisine in a relaxed country style setting.
          From simple fare like burgers and salads,
          to our classic Beef Bourguignon and Steak au Poivre.</p> -->
        <div class="restaurant-info margin-top">
          <h5 class="bold">Hours</h5>
          <p>Monday: Closed</p>
          <p>Tuesday - Sunday: 12 PM - 8:30 PM</p>
          <h5 class="bold margin-top">Call us</h5>
          <p>(631) 734-8267</p>
          <h5 class="bold margin-top">Find us here</h5>
          <p>4805 Depot Ln</p>
          <p>Cutchogue, NY 11935</p>
        </div>
        <div class="blurb-width margin-top">
          <p>Please call ahead if you are looking for something specific. We can accommodate some Gluten Free options.</p>
          <p>Enjoy a drink at our comfortable bar or relax outside on our front patio in the summer.</p>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import { dataAnnouncements } from '../data'
import Announcement from './Announcement'

export default {
  components: {
    'app-announcement': Announcement
  },
  name: 'Home',
  metaInfo: {
    title: 'Red Rooster Bistro',
    titleTemplate: '%s | Home',
    meta: [
      {
        name: 'description',
        content: 'Quiet French-American bistro in the heart of the North Fork\'s wine country.'
      },
      {
        name: 'keywords',
        content: 'Red Rooster Cutchogue, Red Rooster Bistro, Red Rooster, Red Rooster Restaurant'
      }
    ]
  },
  data: function () {
    return {
      announcements: dataAnnouncements
    }
  }
}
</script>

<style scoped>
.social-container {
  margin-bottom: 20px;
}

.social {
  width: 50px;
  height: 50px;
}

@media only screen and (max-width: 600px) {
  .social {
    width: 40px;
    height: 40px;
  }
  .home-border {
    border-top: 1px solid #8a0707;
    margin: auto;
    margin-bottom: 20px;
    width: 90%;
  }
}

.margin-top {
  margin-top: 40px;
}

.blurb-width {
  max-width: 300px;
}

.anouncement-width {
  max-width: 450px;
}

@media only screen and (max-width: 600px) {
  .social-container, .home-content {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue